module.exports = __webpack_public_path__ + "assets/img/05a.54080012.png";